// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"c8bc0447","513":"e11729ea","703":"4341e310"}[chunkId] + ".chunk.js";
};